import { graphql, useStaticQuery } from 'gatsby';
import { ImageObject } from '../../types';
import { IGatsbyImageData } from 'gatsby-plugin-image'

//define variable and its type
interface GallerySectionQueryResult {
    images: {
      edges: [
        {
          node: {
            name: string
            childrenImageSharp: [
              {
                thumb: IGatsbyImageData
                full: IGatsbyImageData
              }
            ]
          }
        }
      ]
    }
}


export const useLocalDataSource = (): GallerySectionQueryResult => {
    return useStaticQuery(graphql`
    query GallerySectionQuery {
    images:allFile(
      filter: {extension: {regex: "/jpg|png/"}, relativeDirectory: {regex:"/gallery/"}}
      sort: {fields: modifiedTime, order: ASC}
    ) {
      edges {
        node {
          name
          childrenImageSharp{
            thumb:gatsbyImageData(width:270
            height:270
            placeholder:BLURRED)
            full:gatsbyImageData(layout:FULL_WIDTH)
          }
        }
      }
    }
  }
    `);
};